import React from "react";

import {
  BlockStack,
  Card,
  Grid,
  InlineGrid,
  SkeletonDisplayText,
  Text,
} from "@shopify/polaris";

import { formatCurrency } from "../../../../utilities";

import { useGetClientStatsQuery } from "../../../../services/api";

// utility object to help guide presentation
const summaryStatCardItems = [
  {
    id: 1,
    title: "Total Opportunities",
    subtitle: "Processed since inception",
    left: {
      title: "Number of Opportunities",
      resultsKey: "countOpportunities",
    },
    right: {
      title: "Sum of Opportunities",
      resultsKey: "sumOpportunities",
      format: "currency",
    },
  },
  {
    id: 2,
    title: "Funded Opportunities",
    subtitle: "Funded since inception",
    left: {
      title: "Count",
      resultsKey: "countOpportunitiesFunded",
    },
    right: {
      title: "Total Amount",
      resultsKey: "sumOpportunitiesFunded",
      format: "currency",
    },
  },
  {
    id: 3,
    title: "Highlights",
    subtitle: "Active opportunities",
    left: {
      title: "Number of Open Deals",
      resultsKey: "countOpportunitiesOpen",
    },
    right: {
      title: "Average Transaction Size",
      resultsKey: "averageOpportunityAmount",
      format: "currency",
    },
  },
];

export function AccountStatistics({ client }) {
  // load the aggregate data from server

  const { data, isLoading, isFetching, isError } = useGetClientStatsQuery({
    account_id: client.id,
  });

  return (
    <Grid columns={{ xs: 1, sm: 1, md: 1, lg: 3, xl: 3 }}>
      {summaryStatCardItems.map((item) => {
        return (
          <Card key={item.id}>
            <BlockStack gap="200">
              <Text as="h2" variant="headingLg">
                {item.title}
              </Text>
              <BlockStack gap="200">
                <Text as="h3" variant="headingMd" tone="subdued">
                  {item.subtitle}
                </Text>
              </BlockStack>
              <InlineGrid gap="500" columns={2}>
                <Text as="h4" variant="bodyMd" tone="subdued">
                  {item.left.title}
                </Text>
                <Text as="h4" variant="bodyMd" tone="subdued">
                  {item.right.title}
                </Text>
              </InlineGrid>

              <InlineGrid gap="500" columns={2}>
                {isLoading || isFetching || isError ? (
                  <>
                    <SkeletonDisplayText maxWidth="100%" size="medium" />
                    <SkeletonDisplayText maxWidth="100%" size="medium" />
                  </>
                ) : (
                  <>
                    <Text as="p" variant="headingXl">
                      {item.left.format && item.left.format === "currency"
                        ? formatCurrency(data[item.left.resultsKey])
                        : data[item.left.resultsKey]}
                    </Text>
                    <Text as="p" variant="headingXl">
                      {item.right.format && item.right.format === "currency"
                        ? formatCurrency(data[item.right.resultsKey])
                        : data[item.right.resultsKey]}
                    </Text>
                  </>
                )}
              </InlineGrid>
            </BlockStack>
          </Card>
        );
      })}
    </Grid>
  );
}
